import React from 'react';
import { SContainer } from './styles';

export const Container = ({ children }) => {
  return <SContainer>{children}</SContainer>;
};
